// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a30e2116","455":"a07c757b","644":"3b41d0c6"}[chunkId] + ".chunk.js";
};